import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { TRIMS } from '@constants';
import { canUpgrade, getCountryInfo, getCurrency } from '@utils';
import { hideModal, displayModal } from '@store/appStateSlice';
import content from './ViewDetails.json';
import styles from './ViewDetails.module.scss';
import moment from '@helpers/moment';
import { getLocalizedContent as l } from '@helpers/languages';

const ViewDetails = ({ configurationData }) => {
  const dispatch = useDispatch();
  const {
    appState: { prefixLanguage },
  } = useSelector(state => state);
  const language = prefixLanguage || 'en';
  const { trim, reservation, order } = configurationData;
  const upgradeCopy =
    TRIMS[trim] === TRIMS['grand_touring']
      ? l(content.waitlist, language)
      : l(content.upgrade, language);
  const dateOfCopy = reservation?.reservationCreated
    ? 'Date of Reservation'
    : 'Date of Order';
  const address = reservation?.address || order?.address;
  const created = reservation?.reservationCreated || order?.orderCreated;
  const currencyCode = reservation?.currencyCode || order?.currencyCode;
  const deposit = reservation?.deposit || order?.deposit;
  const reservationId = reservation?.reservationId || order?.reservationId;
  const dreamWaitlist = reservation?.dreamWaitlist || false;
  const msTime = created * 1000;
  const date = moment(msTime).locale(language).format('L');
  const upgradeAvailable =
    address?.country && !dreamWaitlist
      ? canUpgrade(trim, address?.country)
      : false;
  const countryInfo = address?.country && getCountryInfo(address?.country);
  const currencyInfo = currencyCode && getCurrency(currencyCode);

  const handleUpgrade = () => {
    // close the modal
    dispatch(hideModal());
    // show upgrade modal
    setTimeout(() => {
      dispatch(
        displayModal({
          modalName: 'UPGRADE',
          modalProps: { configurationData },
        })
      );
    }, 750);
  };

  return (
    <div className={styles.ViewDetails}>
      <h4>{l(content.heading, language)}</h4>
      <div className={styles.tableWrap}>
        <div className={styles.details}>
          <span>{l(content.reservationNumber, language)}</span>
          <span>{reservationId}</span>
        </div>
        <div className={styles.details}>
          <span>{dateOfCopy}</span>
          <span>{date}</span>
        </div>
        <div className={styles.details}>
          <span>{l(content.deposit, language)}</span>
          <span>
            {currencyInfo?.symbol}
            {deposit} {currencyCode}
          </span>
        </div>
        <div className={styles.details}>
          <span>{l(content.deliveryLocation, language)}</span>
          <span>{l(countryInfo?.name, language)}</span>
        </div>
        <div className={styles.details}>
          <span>{l(content.model, language)}</span>
          <span>
            {trim}
            <br />
            {upgradeAvailable ? (
              <a className={styles.upgradeButton} onClick={handleUpgrade}>
                {upgradeCopy}
              </a>
            ) : null}
            {dreamWaitlist ? (
              <p className={styles.waitlisted}>
                {l(content.waitlisted, language)}
              </p>
            ) : null}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ViewDetails;
